import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Agenda_table_interface } from '@bludata/common-interfaces';
import dayjs from 'dayjs';
import { Appointment_interface } from '@focus.cloud/src/calendar/interfaces/Appointment';

export interface LaboratorioSliceState {
  appointmentLoading: boolean;
  appuntamenti: Appointment_interface[];
  visualizzazioneSelected: 'utente' | 'studio';
  tipoCalendario: 'Day' | 'Month' | 'Week' | '4Days';
  filiale?: string;
  agendaZoom: number;
  agendaDate: Date;
  codice: string[];
  appointmentForm?: Agenda_table_interface;
  clientSearched: string;
  refetch: boolean;
  richiestaAppuntamento?: Appointment_interface;
  rightClick?: any;
}

const initialState: LaboratorioSliceState = {
  appointmentLoading: false,
  appuntamenti: [],
  visualizzazioneSelected: 'utente',
  tipoCalendario: 'Week',
  agendaZoom: 4,
  agendaDate: new Date(),
  codice: [],
  clientSearched: '',
  refetch: false,
};

export const AgendaOldSlice = createSlice({
  name: 'agendaold',
  initialState,
  reducers: {
    setAppuntamenti(
      state: LaboratorioSliceState,
      action: PayloadAction<Appointment_interface[]>,
    ) {
      state.appuntamenti = action.payload;
    },
    setAppuntamentoFromIndex(
      state: LaboratorioSliceState,
      action: PayloadAction<{
        index: number;
        appuntamento: Appointment_interface;
      }>,
    ) {
      state.appuntamenti[action.payload.index] = action.payload.appuntamento;
    },
    addRichiestaAppuntamento(
      state: LaboratorioSliceState,
      action: PayloadAction<Appointment_interface | undefined>,
    ) {
      if (state.filiale !== action.payload?.filiale)
        state.filiale = action.payload?.filiale;
      if (
        action.payload !== undefined &&
        action.payload.appointment !== undefined
      )
        state.agendaDate = dayjs(
          action.payload.appointment.data,
          'YYYY-MM-DD',
        ).toDate();

      state.richiestaAppuntamento = action.payload;
    },
    setFiliale(state: LaboratorioSliceState, action: PayloadAction<string>) {
      state.filiale = action.payload;
      state.richiestaAppuntamento = undefined;
    },
    setAppointmentLoading(
      state: LaboratorioSliceState,
      action: PayloadAction<boolean>,
    ) {
      state.appointmentLoading = action.payload;
    },
    setTipoCalendario(
      state: LaboratorioSliceState,
      action: PayloadAction<'Day' | 'Month' | 'Week' | '4Days'>,
    ) {
      state.tipoCalendario = action.payload;
    },
    setVisualizzazioneSelected(
      state: LaboratorioSliceState,
      action: PayloadAction<'utente' | 'studio'>,
    ) {
      state.visualizzazioneSelected = action.payload;
      state.codice = [];
    },
    setAgendaZoom(state: LaboratorioSliceState, action: PayloadAction<number>) {
      state.agendaZoom = action.payload;
    },
    setAgendaDate(state: LaboratorioSliceState, action: PayloadAction<Date>) {
      state.agendaDate = action.payload;
      state.richiestaAppuntamento = undefined;
    },
    setAgendaCodice(
      state: LaboratorioSliceState,
      action: PayloadAction<string[]>,
    ) {
      state.codice = action.payload;
      state.richiestaAppuntamento = undefined;
    },
    setAppointmentForm(
      state: LaboratorioSliceState,
      action: PayloadAction<Agenda_table_interface | undefined>,
    ) {
      state.appointmentForm = action.payload;
      state.richiestaAppuntamento = undefined;
    },
    setClientSearched(
      state: LaboratorioSliceState,
      action: PayloadAction<string>,
    ) {
      state.clientSearched = action.payload;
    },
    setRefetch(state: LaboratorioSliceState) {
      state.refetch = !state.refetch;
    },
    setRightClick(
      state: LaboratorioSliceState,
      action: PayloadAction<any | undefined>,
    ) {
      state.rightClick = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setAppuntamenti,
  setAppuntamentoFromIndex,
  setAppointmentLoading,
  setVisualizzazioneSelected,
  setFiliale,
  setAgendaZoom,
  setAgendaDate,
  setTipoCalendario,
  setAgendaCodice,
  setAppointmentForm,
  setClientSearched,
  setRefetch,
  addRichiestaAppuntamento,
  setRightClick,
} = AgendaOldSlice.actions;
export default AgendaOldSlice.reducer;
